export default __webpack_public_path__ + "static/media/storyboard.5ff2cf5a.svg";